import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M11.3346 9.33268V13.3327M9.33464 11.3327H13.3346M4.0013 6.66602H5.33464C6.07101 6.66602 6.66797 6.06906 6.66797 5.33268V3.99935C6.66797 3.26297 6.07101 2.66602 5.33464 2.66602H4.0013C3.26492 2.66602 2.66797 3.26297 2.66797 3.99935V5.33268C2.66797 6.06906 3.26492 6.66602 4.0013 6.66602ZM10.668 6.66602H12.0013C12.7377 6.66602 13.3346 6.06906 13.3346 5.33268V3.99935C13.3346 3.26297 12.7377 2.66602 12.0013 2.66602H10.668C9.93159 2.66602 9.33464 3.26297 9.33464 3.99935V5.33268C9.33464 6.06906 9.93159 6.66602 10.668 6.66602ZM4.0013 13.3327H5.33464C6.07101 13.3327 6.66797 12.7357 6.66797 11.9993V10.666C6.66797 9.92964 6.07101 9.33268 5.33464 9.33268H4.0013C3.26492 9.33268 2.66797 9.92964 2.66797 10.666V11.9993C2.66797 12.7357 3.26492 13.3327 4.0013 13.3327Z" />
  </svg>
);
